// Feedtracking file
import { Component, OnInit } from '@angular/core';
// import { AngularIndexedDB } from 'angular2-indexeddb';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorage } from '../services/local-storage';
import { SharedService } from '../services/shared.service';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from '../services/Spinner.service';
import { ObjectStore } from '.././models/object-store';
import { Entity, Todo } from '../models/entity';
import { IndexedDBService } from '.././services/indexdb.service';
import { TodoComponent } from '../todo.component';
import { MapsAPILoader } from 'angular2-google-maps/core';
//import { PushNotificationsService } from 'angular2-notifications'
// import {onesignal} from '../localdb/onesignal';
import * as moment from 'moment-timezone';
import { } from '@types/googlemaps';
@Component({
    selector: 'app-feedtracking',
    templateUrl: './feedtracking.component.html',
    styleUrls: ['./feedtracking.component.css'],
    providers: [SharedService, IndexedDBService, ObjectStore, TodoComponent]
})
export class FeedtrackingComponent implements OnInit {
    token: string;
    userID: number;
    getGeofenceId: number;
    serialNumber: number;
    getId: number = 0;
    flag: number = 0;
    dateFlag: number = 0;
    feedcompare = [];
    feedValue = {};
    feedArray: any[];
    geofenceIdArr = [];
    count: number = 0;
    public latitude: number;
    public longitude: number;
    location = {};
    notificationList = [];
    arrayTemp = [];
    distanceResult = [];
    getfeedValue = [];
    allrecords = { bar: [] }
    obj = {};
    trueFlag: number;
    syncnotificationflag = [];
    mytempresult = [];
    sortedArray = [];
    distCalc: number = 0;
    getcurrentlatlongresult = [];
    timezomeGuess;
    groupNotification = [];
    singleNotification = [];
    constructor(private localstorage: LocalStorage, private shareService: SharedService, private loaderService: LoaderService, public indexedDB: IndexedDBService, public todo: TodoComponent, private objectstore: ObjectStore, public entity: Entity) {
        this.timezomeGuess = moment.tz.guess();
    }


    ngOnInit() {

        this.flag = 0;
    }

    // Get Data from Server

    startservice() {
        this.userID = parseInt(this.localstorage.getStorage('userID'))
        this.token = this.localstorage.getStorage('token');
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.setPosition.bind(this));
        }
        else {
        }


    }

    // Get Lat Long after few second 

    getLatLong() {
        this.getcurrentlatlongresult = [];
        var getUserType = parseInt(this.localstorage.getStorage('usertype'));
        if (getUserType === 1) {
            this.getcurrentlatlongresult = this.shareService.getCurrentLatLong();
            var pinglat = this.getcurrentlatlongresult[0];
            var pinglong = this.getcurrentlatlongresult[1];
            var distance = (this.getcurrentlatlongresult[2])
            this.pingservicestart(distance)
        }
    }
    // Get user current lat and long
    setPosition(position) {
        this.location = position.coords;
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        //Get data after certain period of Time  


        if (this.latitude && this.longitude) {
            // this.shareService.getAllFeed('user/campaign/getNearByCampaign/' + this.latitude + "/" + this.longitude + '?currentPage=1&currentSize=1000&timeZone=' + this.timezomeGuess, null, this.token).subscribe((result) => {
            //     this.feedValue = result;
            //     if (this.feedValue) {
            //         this.feedservicedb(this.feedValue);
            //     }
            // })

            this.mytempresult = [];

            this.indexedDB.getAllRecordsAsync("TodoStore").forEach(
                (record: Todo) => {
                    if (record.notificationstatus === 1) {
                        this.sorttimebased(record);
                        record.notificationstatus = 0;
                    }
                    this.indexedDB.editRecordAsync("TodoStore", record).forEach(
                        (readyState) => { }, null
                    )
                }
            )
                .then(() => {
                    // if (this.mytempresult.length > 0) {
                        var getarrayid = [];
                        for (var i = 0; i < this.mytempresult.length; i++) {
                            //getarrayid[i] = (this.mytempresult[i].id);
                            getarrayid.push({
                                "campaignId": this.mytempresult[i].id,
                                "syncDateTime": this.mytempresult[i].notificationtime,
                            })

                        }

                        //  var campaignIds = {"campaignIds":getarrayid};
                console.log("getarrayid 6666");
                                console.log(getarrayid);

                        this.shareService.callApiWithToken('user/campaign/sync?timeZone=' + this.timezomeGuess, getarrayid, this.token)
                            .subscribe((syncResult) => {
                               

                                this.shareService.getAllFeed('user/campaign/getNearByCampaign/' + this.latitude + "/" + this.longitude + '?currentPage=1&currentSize=1000&timeZone=' + this.timezomeGuess, null, this.token).subscribe((result) => {
                                  
                                    this.feedValue = result;
                                    if (this.feedValue) {
                                        this.feedservicedb(this.feedValue);
                                    }
                                })
                        })
                    // }
                    // else{
                    //     console.log("tempresult is 0");
                    // }
                })
                // .then(() => {
                //     this.shareService.getAllFeed('user/campaign/getNearByCampaign/' + this.latitude + "/" + this.longitude + '?currentPage=1&currentSize=1000&timeZone=' + this.timezomeGuess, null, this.token).subscribe((result) => {
                //         this.feedValue = result;
                //         if (this.feedValue) {
                //             this.feedservicedb(this.feedValue);
                //         }
                //     })
                // }
                // )

        }
    }


    // Feed data into local DB based on unique geofence ID;
    feedservicedb(feedValue) {
        this.indexedDB.getTotalRecord("TodoStore").forEach(
            (record: string) => {
                this.getId = parseInt(record);
            }
        )

            .then(
            () => {
                this.indexedDB.getAllRecordsAsync("TodoStore").forEach(
                    (record: Todo) => {
                        if (record.todoId) {
                            this.trueFlag = 0;
                            // Check if server new data is already exist in localDB
                            for (var i = 0; i < feedValue.data.length; i++) {
                                if (record.todoId === feedValue.data[i].id) {
                                    record.notificationEndTime = feedValue.data[i].endAt;
                                    record.radius = feedValue.data[i].visibilityRadius;
                                    record.lat = feedValue.data[i].latitude;
                                    record.long = feedValue.data[i].longitude;
                                    record.cendTime = feedValue.data[i].campaignDuration[0].endTime;
                                    record.cstartTime = feedValue.data[i].campaignDuration[0].startTime;
                                    //record.entryStatus = record.entryStatus;
                                    this.indexedDB.editRecordAsync("TodoStore", record).forEach(
                                        (readyState) => { }, null

                                    );

                                    //  Updates the entity. 

                                    this.entity.editTodo(record);
                                    this.trueFlag = 1;
                                    continue;
                                }

                            }

                            if (!(this.trueFlag)) {
                                this.indexedDB.deleteRecordAsync("TodoStore", record.todoId).forEach(
                                    (readyState) => { }, null

                                )
                            }
                        }
                    }
                )
            }
            )
            .then(
            () => {
                for (var i = 0; i < feedValue.data.length; i++) {
                    var record: Todo = new Todo();
                    var indexEle = this.geofenceIdArr.indexOf(feedValue.data[i].id);
                    if (indexEle == -1) {
                        this.geofenceIdArr.push(feedValue.data[i].id);
                        record.todoId = feedValue.data[i].id
                        record.cendTime = feedValue.data[i].campaignDuration[0].endTime;
                        record.cstartTime = feedValue.data[i].campaignDuration[0].startTime;
                        record.description = feedValue.data[i].description;
                        record.notificationStartTime = feedValue.data[i].startAt;
                        record.entryStatus = feedValue.data[i].entryStatus;
                        record.lat = feedValue.data[i].latitude;
                        record.long = feedValue.data[i].longitude;
                        record.segment = feedValue.data[i].segment;
                        record.segmentName = feedValue.data[i].segmentName;
                        record.notificationEndTime = feedValue.data[i].endAt;
                        record.radius = feedValue.data[i].visibilityRadius;
                        record.notificationstatus = 0;
                        record.setnotificationTime = 0;
                        this.indexedDB.addRecordAsync("TodoStore", record).forEach(
                            // Next.

                            (readyState) => { }, null

                        );
                        //this.getId = this.getId + 1;
                        //record.todoId  = this.getId; 
                        // Updates the entity. 
                        this.entity.addTodo(record);
                    }

                }

            }
            ).

            then(
            () => {
                this.recordcheck();
            })
        // }).then(
        //     () => {
        //         this.callNotification();
        //     }
        // )


    }

    recordcheck() {
        this.allrecords = { bar: [] };
        // Gets all records from "TodoStore".
        this.indexedDB.getAllRecordsAsync("TodoStore").forEach(
            (record: Todo) => {
                var key;
                var dbLat = record.lat;
                var dbLong = record.long;
                var indexEle = this.geofenceIdArr.indexOf(record[Object.keys(record)[0]]);
                if (indexEle == -1) {
                    this.geofenceIdArr.push(record[Object.keys(record)[0]]);

                }
                var distance = this.calculateDistance(this.latitude, this.longitude, dbLat, dbLong);

                this.obj = record.todoId
                if (distance < record.radius) {
                    // var d = new Date(0);
                    //console.log("UTC changed time" + notificationStartTime1); 
                    // notificationStartTime1 = ("moment"+moment.utc(record.notificationStartTime).local())
                    // notificationEndTime1 = ("moment"+moment.utc(record.notificationEndTime).local())
                    var isDateValid = this.checkNotificationTime(record.notificationStartTime, record.notificationEndTime, record.cstartTime, record.cendTime);
                    if (isDateValid === 1) {
                        var indexDistanceEle = this.distanceResult.indexOf(record[Object.keys(record)[0]]);
                        if (indexDistanceEle == -1) {
                            this.distanceResult.push(record[Object.keys(record)[0]]);

                        }
                    }
                }
                else {

                }
                this.allrecords.bar.push((this.obj));
            }, null

        )




        // .then( () => {

        //     this.indexedDB.getAllRecordsAsync("TodoStore").forEach(
        //         (record: Todo) => {
        //             console.log("getAllRecordsAsync for loop todoshare");
        //             console.log(record);
        //             console.log("record.notificationstatus"+record.notificationstatus);
        //             if (record.notificationstatus === 1) {
        //                 this.sorttimebased(record);
        //                 record.notificationstatus = 0;
        //             }
        //             this.indexedDB.editRecordAsync("TodoStore", record).forEach(
        //                 (readyState) => { }, null
        //             )
        //         }
        //     )
        // })
        // .then(() => {
        //     if (this.mytempresult.length > 0) {
        //         var getarrayid = [];
        //         for (var i = 0; i < this.mytempresult.length; i++) {
        //             //getarrayid[i] = (this.mytempresult[i].id);
        //             getarrayid.push({
        //                 "campaignId": this.mytempresult[i].id,
        //                 "syncDateTime": this.mytempresult[i].notificationtime,
        //             })
        //         }
        //         //  var campaignIds = {"campaignIds":getarrayid};
        //         console.log("getarrayid");
        //         console.log(getarrayid);
        //         this.shareService.callApiWithToken('user/campaign/sync?timeZone=' + this.timezomeGuess, getarrayid, this.token)
        //             .subscribe((syncResult) => {
        //                 console.log("Result from sync");
        //                 console.log(syncResult);
        //         })
        //     }
        //     else{
        //         console.log("tempresult is 0");
        //     }
        // })








            .then(
            () => {
                this.indexedDB.getAllRecordsAsync("TodoStore").forEach(
                    (record: Todo) => {
                        if (record.todoId) {
                            var flagStatus = 0;
                         
                            //this.createnotificationList(record);
                            for (var i in this.distanceResult) {
                                if (record.todoId === this.distanceResult[i]) {

                                    var d = new Date();
                                    var currentTime = d.getTime();

                                    flagStatus = 1;
                                    if (record.entryStatus === 0) {
                                        record.entryStatus = 1;
                                        record.notificationstatus = 1;
                                        record.setnotificationTime = currentTime;
                                        this.createnotificationList(record);
                                        continue;

                                    }

                                }
                            }
                            if (flagStatus === 0) {
                                record.entryStatus = 0;
                                record.notificationstatus = 0;
                                record.setnotificationTime = 0;
                                // this.createnotificationList(record);
                            }
                            this.indexedDB.editRecordAsync("TodoStore", record).forEach(
                                (readyState) => { }, null

                            );

                            //  Updates the entity. 
                            this.entity.editTodo(record);

                        }
                    });
            })
            .then(() => {
                                console.log("callNotification before");

                    if(this.mytempresult.length > 0){
                console.log("callNotification");
                this.callNotification();
                    }
            })
    }

    createnotificationList(notificationrecord) {
        console.log("createnotificationList");
        this.syncnotificationflag.push(notificationrecord);
        console.log(this.syncnotificationflag);
    }

onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
}

    callNotification() {
        var notificationCount = 1;
        var notificationsId = [];
        var finalNotificationsId = [];
        var singleNotificationsId = [];
        this.groupNotification = [];
        this.singleNotification = [];
        var disableNotificationID;
        var singleNotifyFlag = 1;
        var groupNotifyFlag = 1;
        var intArr = [];
        var getGroupNotificationStatus = this.localstorage.getStorage('groupnotificationstatus');
        disableNotificationID = String((this.localstorage.getStorage('disablenotificationID')));
        let arrayId = disableNotificationID.split(",");
        arrayId = arrayId.filter(this.onlyUnique);
        for (var i = 0; i < arrayId.length; i++)
            intArr.push(parseInt(arrayId[i]));
             this.syncnotificationflag = this.syncnotificationflag.filter( this.onlyUnique );

        if (this.syncnotificationflag.length > 0) {
            for (var k = 0; k < this.syncnotificationflag.length; k++) {
                notificationCount = 1;
                singleNotifyFlag = 1;
                groupNotifyFlag = 1;
                notificationsId = [];
                var indexEle = finalNotificationsId.indexOf(this.syncnotificationflag[k].todoId);

                if (indexEle == -1) {
                    // notificationsId =[];
                    finalNotificationsId.push(this.syncnotificationflag[k].todoId);
                    notificationsId.push(this.syncnotificationflag[k].todoId);
                    if (getGroupNotificationStatus) {
                        if (disableNotificationID) {
                            for (var n = 0; n < intArr.length; n++) {
                                if (intArr[n] == this.syncnotificationflag[k].segment) {
                                    groupNotifyFlag = 0;
                                    break;
                                }
                            }

                        }
                        else {
                            groupNotifyFlag == 1;
                        }
                        if (groupNotifyFlag === 1) {
                            for (var j = k + 1; j < this.syncnotificationflag.length; j++) {
                                if (this.syncnotificationflag[j].segment === this.syncnotificationflag[k].segment) {
                                    notificationCount++;
                                    finalNotificationsId.push(this.syncnotificationflag[j].todoId);
                                    notificationsId.push(this.syncnotificationflag[j].todoId);
                                }
                            }
                            this.groupNotification = [];
 notificationsId = notificationsId.filter( this.onlyUnique );
console.log("notificationsId group"+notificationsId);
                            this.groupNotification.push({
                                "count": notificationCount,
                                "id": notificationsId,
                                "description": this.syncnotificationflag[k].segmentName
                            })

                           
                            this.shareService.groupPushNotification(this.groupNotification, this.userID).subscribe((result) => {


                            })
                        }
                    }
                    //                this.groupNotification=[];          
                    //                 if(notificationCount>1) {      
                    //                 this.groupNotification.push({
                    //                 "count":notificationCount,
                    //                 "id": notificationsId,
                    //                 "description" : this.syncnotificationflag[k].segmentName
                    //                     })  
                    //                  this.shareService.groupPushNotification(this.groupNotification, this.userID).subscribe((result) => {


                    // })   
                    //                 } 
                    else {
                               this.syncnotificationflag[k].todoId = this.syncnotificationflag[k].todoId.filter( this.onlyUnique );
console.log("notificationsId single"+this.syncnotificationflag[k].todoId);
                        if (disableNotificationID) {
                            for (var n = 0; n < intArr.length; n++) {
                                if (intArr[n] == this.syncnotificationflag[k].segment) {
                                    singleNotifyFlag = 0;
                                    break;
                                }
                            }
                            if (singleNotifyFlag === 1) {
                                this.shareService.singlePushNotification(this.syncnotificationflag[k].description, this.syncnotificationflag[k].todoId, this.userID).subscribe((result) => {
                                });
                            }


                        }
                        else {
                      

                            this.shareService.singlePushNotification(this.syncnotificationflag[k].description, this.syncnotificationflag[k].todoId, this.userID).subscribe((result) => {
                            });
                        }
                    }
                }
            }
        }
        this.syncnotificationflag = [];

    }
    calculateDistance(latitude, longitude, dbLat, dbLong) {
        var radlat1 = Math.PI * latitude / 180;
        var radlat2 = Math.PI * dbLat / 180;
        var theta = longitude - dbLong;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        dist = dist * 1.609344;
        return dist;
    }

    pingservicestart(distance) {
        var servicePing = 1;
        var dataPullPing = 5;
        if (distance >= servicePing) {
            this.recordcheck();
        }
        if (distance > dataPullPing) {
            this.startservice();
        }
        else {
        }
    }

    convertLocalDateToUTCDate(date) {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();

        newDate.setHours(hours - offset);

        return newDate;
    }
    checkNotificationTime(notificationStartTime, notificationEndTime, campaignstarttime, campaignendtime) {
        var CurrentTimeStamp = Math.floor(Date.now());


        CurrentTimeStamp = new Date(CurrentTimeStamp).setHours(0, 0, 0, 0);
        notificationStartTime = new Date(notificationStartTime).setHours(0, 0, 0, 0);
        notificationEndTime = new Date(notificationEndTime).setHours(0, 0, 0, 0);


        var millisecCampaignstarttime = this.milliseconds(campaignstarttime);
        var millisecCampaignEndtime = this.milliseconds(campaignendtime);


        var d = new Date();
        var currentHour = d.getHours();
        var currentMinutes = d.getMinutes();
        var currenttime = currentHour.toString() + '.' + currentMinutes.toString();
   
        var milliseccurrentTime = this.milliseconds(currenttime);


        //  if((CurrentTimeStamp > notificationStartTime && CurrentTimeStamp < notificationEndTime)) {
        if ((CurrentTimeStamp >= notificationStartTime && CurrentTimeStamp < notificationEndTime) && (milliseccurrentTime >= millisecCampaignstarttime && milliseccurrentTime < millisecCampaignEndtime)) {
            this.dateFlag = 1;
        }
        else {
            this.dateFlag = 0;
        }
        return this.dateFlag;
    }

    sorttimebased(getrecord) {
   
console.log("sorttimebased 666");
console.log(getrecord);


        if (this.mytempresult.length === 0) {
            this.mytempresult.push({
                "notificationtime": getrecord.setnotificationTime,
                "id": getrecord.todoId,
            })
        }
        else {
            this.mytempresult.push({
                "notificationtime": getrecord.setnotificationTime,
                "id": getrecord.todoId
            })
            this.mytempresult.sort(function (a, b) {
                return (a.setnotificationTime - b.setnotificationTime);
            })
                .sort(function (a, b) {
                    return (a.setnotificationTime - b.setnotificationTime);
                });

        }
        
    }

    millisecondsStart(gettime) {
        var time = gettime;
        time = (time).toString();
        time = time.split('.')
        if (time.length > 1) {
            var timemillisecondsnumber = 0;
            var timemilliseconds = ((+time[0] * (60000 * 60)) + (+time[1] * 60000) + (+5 * 60000));

        }
        else {
            var timemilliseconds = ((+time[0] * (60000 * 60)) + (+5 * 60000));
        }
        return (timemilliseconds);
    }
    milliseconds(gettime) {
        var time = gettime;
        time = (time).toString();
        time = time.split('.')
        if (time.length > 1) {
            var timemillisecondsnumber = 0;
            var timemilliseconds = ((+time[0] * (60000 * 60)) + (+time[1] * 60000));

        }
        else {
            var timemilliseconds = ((+time[0] * (60000 * 60)));
        }
        return (timemilliseconds);
    }



}




// WEBPACK FOOTER //
// ./src/app/feedtracking/feedtracking.component.ts